<template>
  <div id="_qlqn_admin_group_usr_ls" class="bg-grey-2 q-pa-md">
    <div class="fit column justify-center items-center" v-if="loading">
      <Loading />
    </div>
    <div class="fit column" v-else-if="groupDetail">
      <header class="row no-wrap justify-between items-center">
        <div class="row items-center">
          <span
            style="font-size: 1.2rem"
            class="text-bold"
            :title="groupDetail.name"
          >
            {{ groupDetail.name.substr(0, 10) }}
            {{ groupDetail.name.length > 10 ? "..." : "" }}
          </span>
          <span class="row items-center text-grey text-caption  cursor-pointer">
            <q-icon name="fas fa-edit" class="q-mx-sm"> </q-icon>
            <span>修改小组名称</span>
            <q-popup-edit
              :disable="adminStatusStore[REMOVING_GROUP_MEMBERS]"
              v-model="editGroupNameInput"
              dense
              buttons
              persistent
              title="修改分组名称"
              label-set="修改"
              label-cancel="取消"
              anchor="top right"
              @save="(value) => updateGroupInfo({ name: value }, true)"
              @before-show="editGroupNameInput = groupDetail.name"
            >
              <q-input filled dense autofocus v-model="editGroupNameInput" />
            </q-popup-edit>
          </span>
        </div>

        <!-- link -->
        <q-icon name="fas fa-link" size="12px"></q-icon>

        <!-- 样本 -->
        <div class="row items-center">
          <span v-if="groupDetail.sample_group">
            {{ groupDetail.sample_group.name }}
          </span>
          <span class="text-grey text-caption" v-else>未指定样本组</span>
          <span
            class="row items-center text-grey text-caption cursor-pointer"
            @click="showBindSampleGroupDialog = true"
          >
            <q-icon name="fas fa-edit" class="q-mx-sm" />
            <span>修改样本组</span>
          </span>
        </div>
      </header>

      <!-- 描述 -->
      <section
        class="row full-width no-wrap justify-between items-center q-py-md"
      >
        <div
          style="width: 70%"
          class="text-grey-7 row items-center row no-wrap"
        >
          <div style="white-space: pre-wrap;">
            {{ groupDetail.description }}
          </div>
          <div
            class="row items-center justify-center bg-white cursor-pointer q-ml-md"
            style="width: 36px;height: 36px;border-radius: 10px;flex-shrink: 0"
          >
            <q-icon name="fas fa-edit" size="12px" />
            <q-popup-edit
              :disable="adminStatusStore[REMOVING_GROUP_MEMBERS]"
              v-model="editGroupDescInput"
              max-width="400px"
              content-style="width: 360px"
              dense
              buttons
              persistent
              title="修改分组描述"
              label-set="修改"
              label-cancel="取消"
              anchor="top right"
              @save="(value) => updateGroupInfo({ description: value })"
              @before-show="editGroupDescInput = groupDetail.description"
            >
              <q-input
                type="textarea"
                filled
                dense
                autofocus
                v-model="editGroupDescInput"
              />
            </q-popup-edit>
          </div>
        </div>

        <!-- 总体进度 -->
        <div style="width: 45%; flex-shrink: 0" class="column items-center ">
          <span class="text-caption">小组完成总体情况</span>
          <span
            class="text-grey text-caption q-py-md"
            v-if="isNaN(groupProgress.NOT_STARTED)"
          >
            组长未分配样本
          </span>
          <div v-else class="row no-wrap items-center">
            <div class="column items-center q-ml-sm">
              <span class="text-grey text-caption">未开始</span>
              <q-circular-progress
                show-value
                class="text-red "
                :value="
                  parseInt(
                    ((groupProgress.NOT_STARTED || 0) / groupProgress.SUM) * 100
                  )
                "
                size="50px"
                track-color="grey-4"
                color="red"
              >
                {{ groupProgress.NOT_STARTED }}
              </q-circular-progress>
            </div>
            <div class="column items-center q-ml-sm">
              <span class="text-grey text-caption">进行中</span>
              <q-circular-progress
                show-value
                class="text-primary"
                :value="
                  parseInt(
                    ((groupProgress.STARTED || 0) / groupProgress.SUM) * 100
                  )
                "
                size="50px"
                track-color="grey-4"
                color="primary"
              >
                {{ groupProgress.STARTED }}
              </q-circular-progress>
            </div>
            <div class="column items-center q-ml-sm">
              <span class="text-grey text-caption">已完成</span>
              <q-circular-progress
                show-value
                class="text-green"
                :value="
                  parseInt(
                    ((groupProgress.FINISHED || 0) / groupProgress.SUM) * 100
                  )
                "
                size="50px"
                track-color="grey-4"
                color="green"
              >
                {{ groupProgress.FINISHED }}
              </q-circular-progress>
            </div>
          </div>
        </div>
      </section>

      <MemberList
        class="col-grow"
        :group-id="groupDetail.id"
        :users="groupDetail.users"
        @updated="fetchGroupDetail($route.query._ug)"
        @deleted="resolveGroupDeleted"
      />
    </div>
    <div class="fit column justify-center items-center" v-else>
      <Empty
        :text="
          groupId
            ? '未找到分组，您可能没有访问的权限或分组已被删除'
            : '请在左侧选择一个分组'
        "
      />
    </div>

    <q-dialog v-model="showBindSampleGroupDialog" persistent>
      <BindSampleGroup
        v-if="groupDetail"
        :group-id="groupDetail.id"
        :band-group="groupDetail.user_group"
        @cancel="showBindSampleGroupDialog = false"
        @updated="bindSampleGroupSuccessed"
      />
    </q-dialog>
  </div>
</template>

<script>
import { getGroupDetail } from "@/api/endpoints/group/getGroupDetail";
import { updateGroup } from "@/api/endpoints/group/updateGroup";
import { EventBus } from "@/bus/index";
import {
  GROUP_DETAIL_CHANGED,
  GROUP_MEMBER_DETAIL_CHANGE,
} from "@/bus/admin.events";
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";
import AdminCommonStatus from "@/views/Admin/mixins/status.mixin";

export default {
  mixins: [AdminCommonStatus],
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),
    MemberList: () => import("./MemberList"),
    BindSampleGroup: () => import("./BindSampleGroup"),
    CircularProgress: () =>
      import("@/components/progress-bar/CircularProgress"),
  },
  data() {
    return {
      groupDetail: null,
      loading: false,

      editGroupNameInput: "",
      editGroupDescInput: "",

      REMOVING_GROUP_MEMBERS,
      showBindSampleGroupDialog: false,
    };
  },

  mounted() {
    EventBus.$on(GROUP_MEMBER_DETAIL_CHANGE, this.fetchGroupDetail);
  },
  beforeDestroy() {
    EventBus.$off(GROUP_MEMBER_DETAIL_CHANGE, this.fetchGroupDetail);
  },

  computed: {
    groupId() {
      return this.$route.query._ug;
    },

    groupProgress() {
      const { groupDetail } = this;
      if (!groupDetail) return {};
      let sum = 0,
        finished = 0,
        not_started = 0,
        started = 0;
      for (let user of groupDetail.users || []) {
        const samples = (user || {}).samples || [];
        sum += samples.length;
        for (let sample of samples) {
          if (sample.sample_status == 1) not_started++;
          else if (sample.sample_status == 2) started++;
          else finished++;
        }
      }
      return {
        SUM: sum,
        NOT_STARTED: not_started,
        STARTED: started,
        FINISHED: finished,
      };
    },
  },

  watch: {
    groupId: {
      immediate: true,
      handler(id) {
        if (id) this.fetchGroupDetail(id);
      },
    },
  },

  methods: {
    /**
     * 获取分组详情
     */
    async fetchGroupDetail(groupId = this.groupId) {
      this.loading = true;
      this.groupDetail = null;
      try {
        const res = await getGroupDetail(groupId);
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.messgae,
          });
        } else {
          // console.log(res);
          this.$set(this, "groupDetail", res);
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },

    /**
     * 更新分组的基本信息
     */
    async updateGroupInfo(info, refreshGroupList = false) {
      if (!info.name && !info.description) return;
      if (info.name && info.name === this.groupDetail.name) return;
      if (info.description && info.description === this.groupDetail.description)
        return;
      this.loading = true;
      try {
        const updateRes = await updateGroup(this.groupDetail.id, info);
        if (updateRes.status || updateRes.error) {
          this.$q.notify({
            type: "danger",
            message: "更新分组信息失败",
          });
          this.loading = false;
        } else {
          this.$q.notify({
            type: "success",
            message: "分组信息已更新",
          });
          if (refreshGroupList) EventBus.$emit(GROUP_DETAIL_CHANGED);

          await this.fetchGroupDetail(this.groupDetail.id);
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      } finally {
      }
    },

    /**
     * 分组删除以后的处理
     */
    resolveGroupDeleted() {
      EventBus.$emit(GROUP_DETAIL_CHANGED);
      this.$router.replace({
        query: {
          ...this.$route.query,
          _ug: undefined,
          _gu: undefined,
        },
      });
      this.groupDetail = null;
    },

    /**
     * 绑定样本成功后的回调
     */
    bindSampleGroupSuccessed() {
      this.showBindSampleGroupDialog = false;
      this.fetchGroupDetail();
    },
  },
};
</script>
